export default "__VITE_ASSET__D$bG6XB1__"